
<div *ngIf="draftReviews.length >= 1" class="pt-4">
  <div *ngFor="let draft of draftReviews.slice().reverse() " style="display: flex; justify-content: center; align-items: center; flex-direction: row;">
    <button (click)="goToPaymentPage(draft.reviewDetails._id)"  class="gabadoo-review-card active-gabadoo-review-card" >
    <span class="gabadoo-review-card-name">
      {{ draft.childInfo.childName | titlecase }} <br>
    </span>
      <span class="gabadoo-review-card-description">
      <strong>{{ draft.reviewDetails.createdAt | date :  "dd/MM/y"}}</strong>
      <p><strong>{{draft.reviewDetails.areaOfFocus}}</strong></p>
    </span>
    </button>
  </div>
</div>

<div *ngIf="draftReviews.length == 0" class="pt-4">
  <div  style="display: flex; justify-content: center; align-items: center; flex-direction: row;">
    <button  class="gabadoo-review-card active-gabadoo-review-card" style="margin-top: 40px" >
    <span class="gabadoo-review-card-name" style="font-size: 1rem">
      No Drafts Found
    </span>
    </button>
  </div>
</div>


<div style="display: flex; justify-content: center; align-items: center; flex-direction: row; opacity: 0.5;">
  <button   class="gabadoo-review-card active-gabadoo-review-card" >
  <span class="gabadoo-review-card-name">
    Empty Gabadoo <br>
  </span>
    <span class="gabadoo-review-card-description">
    Gabadoo will go here
  </span>
  </button>
</div>
